export default "__VITE_ASSET__BLbdKVUc__"